import { useMemo } from "react";

export default function Table({
  TableHead,
  TableData,
  tableRef,
  tableRowStyle = "",
  thStyle = "",
  tbodyStyle = "",
  trStyle = "",
  tdStyle = "",
  containerStyle = "",
  tableStyle = "",
  onRowClick = () => null,
}) {
  const allKeysPresent = useMemo(
    () =>
      TableHead.every((header) =>
        TableData?.every((dataItem) =>
          Object.keys(dataItem)
            .map((el) => el.toLowerCase())
            .includes(header.accessorKey.toLowerCase())
        )
      ),
    [TableHead, TableData]
  );

  if (!allKeysPresent) {
    throw new Error(
      "Table data does not contain all required accessor keys of headers or table data objects don't have the same keys. Check data and headers arrays !"
    );
  }

  return (
    <>
      <div className={`my-4 overflow-auto mx-auto max-w-full w-full ${containerStyle}`}>
        <table
          className={` px-4 leading-normal  min-w-[800px] custom_table w-full ${tableStyle}`}
          ref={tableRef}
        >
          <thead
            className={
              "w-full border-[#888888] border-b  rounded-lg whitespace-nowrap bg-[#2A375C]"
            }
          >
            <tr className={`${tableRowStyle}`}>
              {TableHead?.map((item, i) => (
                <th key={i} className={`p-4 font-normal ${thStyle}`}>
                  {item.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={`${tbodyStyle}`}>
            {TableData?.map((row, rowIndex) => (
              <tr
                onClick={onRowClick}
                key={rowIndex}
                className={`border-b py-3 border-[#DBE0E7] last-of-type:border-none hover:bg-header ${trStyle}`}
              >
                {TableHead.map((head, colIndex) => (
                  <td key={colIndex} className={`text-center py-4 ${tdStyle}`}>
                    {head.accessorKey === "image" && row[head.accessorKey] ? (
                      <div className="flex items-center justify-center ">
                        <img
                          alt="img"
                          src={row[head.accessorKey]}
                          width={50}
                          height={50}
                          className="rounded-full size-[50px] object-cover"
                        />
                      </div>
                    ) : (
                      row[head.accessorKey] ?? ""
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
